import Icon from '@ant-design/icons';

const SVG = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="20"
    viewBox="0 0 24 20"
  >
    <g id="archive" transform="translate(0 -2)">
      <path
        id="Path_1091"
        data-name="Path 1091"
        d="M21,8V21H3V8"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
      <rect
        id="Rectangle_450"
        data-name="Rectangle 450"
        width="22"
        height="5"
        transform="translate(1 3)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
      <line
        id="Line_92"
        data-name="Line 92"
        x2="4"
        transform="translate(10 12)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </g>
  </svg>
);

const AntdIcon = (props) => <Icon component={SVG} {...props} />

export default AntdIcon